module.exports = __webpack_public_path__ + "static/media/Uber-Eats-Logo.285dc467.png";